// import React from 'react';

// const Activities = () => {
//   const primaryColor = "rgb(0, 111, 47)";

//   const activities = [
//     {
//       title: "Annual Function — Grand UTSAV",
//       desc: "Our flagship event is a grand spectacle of talent. Children perform on stage—dancing, singing, and acting. A day families look forward to all year.",
//       tag: "Major Event",
//       color: "#FF5722"
//     },
//     {
//       title: "Festival Celebrations",
//       desc: "Diwali, Holi, Christmas, and more—every festival is an opportunity to instil cultural pride and create joyful memories.",
//       tag: "Cultural",
//       color: "#E91E63"
//     },
//     {
//       title: "Field Trips & Excursions",
//       desc: "We take children into the world—museums, parks, and heritage sites. Because real experience is the greatest teacher.",
//       tag: "Exploration",
//       color: "#2196F3"
//     },
//     {
//       title: "Creative Competitions",
//       desc: "Drawing, storytelling, fancy dress, and more—regular competitions give children the chance to build confidence and earn recognition.",
//       tag: "Skill Building",
//       color: "#9C27B0"
//     },
//     {
//       title: "Stars of the Month",
//       desc: "Every month, we celebrate remarkable achievements academically and creatively. Because every child deserves to feel like a star.",
//       tag: "Recognition",
//       color: "#FFC107"
//     }
//   ];

//   return (
//     <div style={{ paddingTop: "140px", backgroundColor: "#fffaf0", minHeight: "100vh", fontFamily: "Segoe UI, sans-serif" }}>
      
//       {/* 🎊 HERO HEADER */}
//       <div style={{ textAlign: "center", padding: "40px 20px" }}>
//         <h1 style={{ color: primaryColor, fontSize: "3rem", fontWeight: "800", marginBottom: "15px" }}>
//           "Hand in Hand, We Learn and Grow"
//         </h1>
//         <p style={{ maxWidth: "800px", margin: "0 auto", fontSize: "1.2rem", color: "#555", lineHeight: "1.6" }}>
//           Life at DPS Kids is never dull. Throughout the year, a rich calendar of cultural, academic, and recreational activities ensures that every child finds their moment to shine.
//         </p>
//       </div>

//       {/* 🎪 ACTIVITIES TIMELINE/GRID */}
//       <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "40px 20px" }}>
//         <div style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//           gap: "30px"
//         }}>
//           {activities.map((act, index) => (
//             <div key={index} style={{
//               background: "#fff",
//               borderRadius: "20px",
//               overflow: "hidden",
//               boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
//               border: "1px solid #eee",
//               transition: "0.3s"
//             }}
//             onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.02)"}
//             onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
//             >
//               {/* Colored Top Bar */}
//               <div style={{ height: "10px", backgroundColor: act.color }}></div>
              
//               <div style={{ padding: "30px" }}>
//                 <span style={{ 
//                   backgroundColor: act.color + "20", 
//                   color: act.color, 
//                   padding: "5px 15px", 
//                   borderRadius: "20px", 
//                   fontSize: "0.8rem", 
//                   fontWeight: "700",
//                   textTransform: "uppercase" 
//                 }}>
//                   {act.tag}
//                 </span>
                
//                 <h3 style={{ marginTop: "15px", marginBottom: "15px", color: "#222" }}>{act.title}</h3>
//                 <p style={{ color: "#666", lineHeight: "1.6", fontSize: "1rem" }}>{act.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* 📸 GALLERY PLACEHOLDER / MOTIVATIONAL TEXT */}
//       <div style={{ 
//         marginTop: "60px", 
//         background: primaryColor, 
//         color: "#fff", 
//         padding: "80px 20px", 
//         textAlign: "center" 
//       }}>
//         <h2 style={{ fontSize: "2.2rem", marginBottom: "20px" }}>Beyond the Classroom</h2>
//         <p style={{ maxWidth: "700px", margin: "0 auto", fontSize: "1.1rem", opacity: "0.9" }}>
//           "Real learning happens when children step up, speak out, dance, draw, perform, and celebrate — together."
//         </p>
//         <div style={{ marginTop: "30px", fontSize: "3rem" }}>
//           🎨 🎭 ⛺ 🎪 🏆
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Activities;

 
import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../Screenss/DataContext";
 
const Activities = () => {
  const primaryColor = "rgb(0, 111, 47)"; // Defined properly
 const { data } = useContext(DataContext);
 const [current, setCurrent] = useState(0);
const galleryItems = data.filter(
    (item) => item.category === "Activities"
  );

  // 🔁 Auto Slide
  useEffect(() => {
    if (galleryItems.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === galleryItems.length - 1 ? 0 : prev + 1
      );
    }, 3000); // 3 sec

    return () => clearInterval(interval);
  }, [galleryItems]);
  const activities = [
    {
      title: "Annual Function — Grand UTSAV",
      desc: "Our flagship event is a grand spectacle of talent. Children perform on stage—dancing, singing, and acting. A day families look forward to all year.",
      tag: "Major Event",
      color: "#FF5722"
    },
    {
      title: "Festival Celebrations",
      desc: "Diwali, Holi, Christmas, and more—every festival is an opportunity to instil cultural pride and create joyful memories.",
      tag: "Cultural",
      color: "#E91E63"
    },
    {
      title: "Field Trips & Excursions",
      desc: "We take children into the world—museums, parks, and heritage sites. Because real experience is the greatest teacher.",
      tag: "Exploration",
      color: "#2196F3"
    },
    {
      title: "Creative Competitions",
      desc: "Drawing, storytelling, fancy dress, and more—regular competitions give children the chance to build confidence and earn recognition.",
      tag: "Skill Building",
      color: "#9C27B0"
    },
    {
      title: "Stars of the Month",
      desc: "Every month, we celebrate remarkable achievements academically and creatively. Because every child deserves to feel like a star.",
      tag: "Recognition",
      color: "#FFC107"
    }
  ];

  return (
    <div style={styles.page}>
      {/* TOP IMAGE HERO */}
      {/* <div style={styles.hero}>
        <img
          src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1600&q=80"
          alt="school activities"
          style={styles.heroImage}
        />
        <div style={styles.heroOverlay} />
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>"Hand in Hand, We Learn and Grow"</h1>
          <p style={styles.heroText}>
            Life at DPS Kids is never dull. Throughout the year, a rich calendar of cultural, academic, and recreational activities ensures that every child finds their moment to shine.
          </p>
        </div>
      </div> */}
  {/* ✅ HERO SLIDER */}
      <section style={styles.hero}>
        <div style={styles.heroImageWrap}>
          
          {galleryItems.length > 0 && (
            <img
              src={galleryItems[current].full_url}
              alt="school banner"
              style={styles.heroImage}
            />
          )}

          {/* <div style={styles.heroOverlay} /> */}

          {/* <div style={styles.heroContent}>
            <h1 style={styles.heroTitle}>
              Building Foundations That Last a Lifetime
            </h1>
            <p style={styles.heroText}>
              A school is more than walls and textbooks — it is where futures are shaped, values are rooted, and dreams take flight.
            </p>
          </div> */}

          {/* ✅ Dots Indicator */}
          <div style={styles.dots}>
            {galleryItems.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  backgroundColor:
                    current === i ? "rgb(0,111,47)" : "#fff",
                }}
              />
            ))}
          </div>

        </div>
      </section>
      {/* ACTIVITIES GRID WITH ANIMATION */}
      <div style={styles.section}>
        <div style={styles.grid}>
          {activities.map((act, index) => (
            <div
              key={index}
              className="activity-card"
              style={{
                ...styles.activityCard,
                borderTopColor: act.color,
              }}
            >
              <div style={{
                ...styles.colorBar,
                backgroundColor: act.color,
              }} />
              <div style={styles.cardContent}>
                <span style={{
                  ...styles.tag,
                  backgroundColor: act.color + "20",
                  color: act.color,
                }}>
                  {act.tag}
                </span>
                <h3 style={styles.activityTitle}>{act.title}</h3>
                <p style={styles.activityDesc}>{act.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* BOTTOM MOTIVATIONAL */}
      <div style={{
        ...styles.bottomSection,
        background: primaryColor,
      }}>
        <h2 style={styles.bottomTitle}>Beyond the Classroom</h2>
        <p style={styles.bottomText}>
          "Real learning happens when children step up, speak out, dance, draw, perform, and celebrate — together."
        </p>
        <div style={styles.emojiRow}>🎨 🎭 ⛺ 🎪 🏆</div>
      </div>

      <style>{`
        .activity-card {
          transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          will-change: transform;
        }

        .activity-card:hover {
          transform: translateY(-12px) scale(1.02);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }

        @media (max-width: 768px) {
          .activity-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Activities;

// const styles = {
//   page: {
//     paddingTop: "140px",
//     backgroundColor: "#fffaf0",
//     minHeight: "100vh",
//     fontFamily: "Segoe UI, sans-serif",
//     overflowX: "hidden",
//   },
//   hero: {
//     width: "100%",
//     marginTop: "120px",
//   },
//   heroImageWrap: {
//     position: "relative",
//     width: "100%",
//     height: "560px",
//     overflow: "hidden",
//     marginTop:-105
//   },
//   heroImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },
//   heroOverlay: {
//     position: "absolute",
//     inset: 0,
//     background: "rgba(0,0,0,0.4)",
//   },
//   heroContent: {
//     position: "absolute",
//     inset: 0,
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     textAlign: "center",
//     padding: "0 20px",
//     color: "#fff",
//   },
//   heroTitle: {
//     fontSize: "2.8rem",
//     fontWeight: "800",
//     marginBottom: "18px",
//     maxWidth: "900px",
//   },
//   heroText: {
//     fontSize: "1.15rem",
//     maxWidth: "800px",
//     opacity: 0.95,
//     lineHeight: 1.7,
//   },
//   section: {
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "50px 20px",
//   },
//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//     gap: "30px",
//   },
//   activityCard: {
//     background: "#fff",
//     borderRadius: "20px",
//     overflow: "hidden",
//     boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
//     border: "1px solid #eee",
//   },
//   colorBar: {
//     height: "10px",
//   },
//   cardContent: {
//     padding: "28px",
//   },
//   tag: {
//     padding: "6px 16px",
//     borderRadius: "20px",
//     fontSize: "0.8rem",
//     fontWeight: "700",
//     textTransform: "uppercase",
//   },
//   activityTitle: {
//     marginTop: "16px",
//     marginBottom: "16px",
//     color: "#222",
//     fontSize: "1.3rem",
//   },
//   activityDesc: {
//     color: "#666",
//     lineHeight: "1.65",
//     fontSize: "1rem",
//   },
//   bottomSection: {
//     color: "#fff",
//     padding: "80px 20px",
//     textAlign: "center",
//   },
//   bottomTitle: {
//     fontSize: "2.2rem",
//     marginBottom: "20px",
//   },
//   bottomText: {
//     maxWidth: "700px",
//     margin: "0 auto",
//     fontSize: "1.1rem",
//     opacity: "0.92",
//   },
//   emojiRow: {
//     marginTop: "30px",
//     fontSize: "3rem",
//   },
// };

const styles = {
  page: {
    paddingTop: "clamp(80px, 10vw, 140px)", // 🔥 responsive spacing
    backgroundColor: "#fffaf0",
    minHeight: "100vh",
    fontFamily: "Segoe UI, sans-serif",
    overflowX: "hidden",
  },

  hero: {
    width: "100%",
    marginTop: "clamp(60px, 8vw, 120px)",
  },

  heroImageWrap: {
    position: "relative",
    width: "100%",
    height: "clamp(250px, 50vw, 560px)", // 🔥 responsive height
    overflow: "hidden",
    marginTop: "clamp(-190px, -5vw, -105px)" // 🔥 controlled negative margin
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },

  heroOverlay: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
  },

  heroContent: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "0 clamp(10px, 4vw, 20px)", // 🔥 mobile safe
    color: "#fff",
  },

  heroTitle: {
    fontSize: "clamp(20px, 5vw, 45px)", // 🔥 responsive text
    fontWeight: "800",
    marginBottom: "12px",
    maxWidth: "900px",
  },

  heroText: {
    fontSize: "clamp(13px, 2vw, 18px)",
    maxWidth: "800px",
    opacity: 0.95,
    lineHeight: 1.7,
  },

  section: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "clamp(30px, 6vw, 50px) 15px",
  },

  /* 🔥 GRID FIX */
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", // 🔥 better responsive
    gap: "clamp(15px, 4vw, 30px)",
  },

  activityCard: {
    background: "#fff",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    border: "1px solid #eee",
  },

  colorBar: {
    height: "8px", // 🔥 slight adjust mobile
  },

  cardContent: {
    padding: "clamp(18px, 4vw, 28px)",
  },

  tag: {
    padding: "5px 14px",
    borderRadius: "20px",
    fontSize: "clamp(10px, 2vw, 13px)",
    fontWeight: "700",
    textTransform: "uppercase",
  },

  activityTitle: {
    marginTop: "12px",
    marginBottom: "12px",
    color: "#222",
    fontSize: "clamp(15px, 2.5vw, 22px)",
  },

  activityDesc: {
    color: "#666",
    lineHeight: "1.6",
    fontSize: "clamp(13px, 2vw, 16px)",
  },

  bottomSection: {
    color: "#fff",
    padding: "clamp(40px, 8vw, 80px) 15px",
    textAlign: "center",
  },

  bottomTitle: {
    fontSize: "clamp(18px, 4vw, 32px)",
    marginBottom: "15px",
  },

  bottomText: {
    maxWidth: "700px",
    margin: "0 auto",
    fontSize: "clamp(13px, 2vw, 18px)",
    opacity: "0.92",
  },

  emojiRow: {
    marginTop: "20px",
    fontSize: "clamp(28px, 5vw, 50px)", // 🔥 responsive emoji
  },
};